import './App.css';
import React from 'react';
import Navbar from './components/Navbar';
import Sidebar from './components/Sidebar';
import Dashboard from './components/Dashboard';
import Login from './components/Login';
import Home from './components/Home';
import Sales from './components/Sales';
import AddSales from './components/AddSales';
import NewSale from './components/NewSale';
import Products from './components/Products';
import ViewAllProducts from './components/ViewAllProducts';
import AddProduct from './components/AddProduct';
import Tea from './components/Tea';
import ViewAllTea from './components/ViewAllTea';
import AddTea from './components/AddTea';
import AddClient from './components/AddClient';
import ViewClient from './components/ViewClient';
import ViewAllClient from './components/ViewAllClient';
import ViewLedger from './components/ViewLedger';
import ViewLedgerTest from './components/ViewLedgerTest';
import ViewStock from './components/ViewStock';
import StockShow from './components/StockShow';
import StockShowTea from './components/StockShowTea';
import EditProducts from './components/EditProducts';
import EditTea from './components/EditTea';
import EditClient from './components/EditClient';
import EditPurchased from './components/EditPurchased';
import ViewPurchased from './components/ViewPurchased';
import Purchased from './components/Purchased';
import PurchageTea from './components/PurchageTea';
import TeaStock from './components/TeaStock';
import TeaTotalSales from './components/TeaTotalSales';
import TeaNewSales from './components/TeaNewSales';
import AddPurchase from './components/AddPurchase';
import NewPurchase from './components/NewPurchase';
import AddDebit from './components/AddDebit';
import AddCredit from './components/AddCredit';
import DebitCredit from './components/DebitCredit';
import ViewStatement from './components/ViewStatement';
import AnnualStatements from './components/AnnualStatements';


import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

const App = () => {


  return (
    <Router>

      <div className="container">
        <Routes>
          <Route path="/home" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/viewallproducts" element={<ViewAllProducts />} />
          <Route path="/addproduct" element={<AddProduct />} />
          <Route path="/tea" element={<Tea />} />
          <Route path="/viewalltea" element={<ViewAllTea />} />
          <Route path="/addtea" element={<AddTea />} />
          <Route path="/addclient" element={<AddClient />} />
          <Route path="/viewclient" element={<ViewClient />} />
          <Route path="/viewallclient" element={<ViewAllClient />} />
          <Route path="/viewledger" element={<ViewLedger />} />
          <Route path="/viewledgertest" element={<ViewLedgerTest />} />
          <Route path="/viewstock" element={<ViewStock />} />
          <Route path="/stockshow" element={<StockShow />} />
          <Route path="/stockshowtea" element={<StockShowTea />} />
          <Route path="/" element={<Login />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/navbar" element={<Navbar />} />
          <Route path="/sidebar" element={<Sidebar />} />
          <Route path="/edit-products/:id" element={<EditProducts />} />
          <Route path="/edit-tea/:id" element={<EditTea />} />
          <Route path="/edit-client/:id" element={<EditClient />} />
          <Route path="/edit-purchase/:id" element={<EditPurchased />} />
          <Route path="/view-purchase/:id" element={<ViewPurchased />} />
          <Route path="/purchased" element={<Purchased />} />
          <Route path="/purchagetea" element={<PurchageTea />} />
          <Route path="/teastock" element={<TeaStock />} />
          <Route path="/teatotalsales" element={<TeaTotalSales />} />
          <Route path="/teanewsales" element={<TeaNewSales />} />
          <Route path="/addpurchase" element={<AddPurchase />} />
          <Route path="/newpurchase" element={<NewPurchase />} />
          <Route path="/sales" element={<Sales />} />
          <Route path="/addsales" element={<AddSales />} />
          <Route path="/newsale" element={<NewSale />} />
          <Route path="/adddebit" element={<AddDebit />} />
          <Route path="/addcredit" element={<AddCredit />} />
          <Route path="/debit-credit" element={<DebitCredit />} />
          <Route path="/viewstatement" element={<ViewStatement />} />
          <Route path="/annual-statements" element={<AnnualStatements />} />

        </Routes>
      </div>

    </Router>
  );
};

export default App;
